(function () {
  'use strict';

  function qs(root, sel) { return (root || document).querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var stage = qs(root, '.sr-gal__stage');
    if (!stage || root.dataset.nabiGalleryReady === '1') return;
    root.dataset.nabiGalleryReady = '1';
    var slides = qsa(root, '.sr-gal__slide');
    var thumbs = qsa(root, '.sr-thumb');
    var prev = qs(root, '.sr-gal__arrow--prev');
    var next = qs(root, '.sr-gal__arrow--next');
    var i = 0;
    var total = slides.length;
    if (!total) return;

    function go(n) {
      i = Math.max(0, Math.min(total - 1, n));
      stage.style.setProperty('--sr-i', String(i));
      slides.forEach(function (s, idx) { s.classList.toggle('is-on', idx === i); });
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-on', idx === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === total - 1;
      if (thumbs[i]) thumbs[i].scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
    }

    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () { go(idx); });
    });
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    go(0);
  }

  /* ---------- Offers + subscribe + buy ---------- */
  function findBuyForm(root) {
    return qs(root, '#nabi-buy-form') ||
      qs(root, 'form.nabi-buy-form') ||
      qs(root, 'form[action*="/cart/add"]');
  }

  function applyOffer(root, offer) {
    if (!root || !offer) return;
    var form = findBuyForm(root);
    var vidInput = form ? qs(form, 'input[name="id"]') : null;
    var priceNow = qs(root, '[data-nabi-price-now]');
    var priceWas = qs(root, '[data-nabi-price-was]');
    var priceSave = qs(root, '[data-nabi-price-save]');
    var offers = qsa(root, '.sr-offer');

    offers.forEach(function (o) { o.classList.toggle('is-on', o === offer); });

    var radio = qs(offer, 'input[type="radio"]');
    if (radio && !radio.checked) radio.checked = true;

    if (vidInput) vidInput.value = offer.getAttribute('data-vid') || '';

    var p = offer.getAttribute('data-price') || '';
    var c = offer.getAttribute('data-compare') || '';
    var s = offer.getAttribute('data-save') || '';
    if (priceNow) priceNow.textContent = p;
    if (priceWas) {
      priceWas.textContent = c;
      priceWas.classList.toggle('is-empty', !c);
    }
    if (priceSave) {
      priceSave.textContent = s ? ('Save ' + s + '%') : '';
      priceSave.classList.toggle('is-empty', !s);
    }
  }

  function syncPlan(root) {
    var form = findBuyForm(root);
    if (!form) return;
    var planInput = qs(form, 'input[name="selling_plan"]');
    var subBtn = qs(root, '.sr-sub');
    var planId = form.getAttribute('data-selling-plan') || '';
    if (!planInput) return;
    var on = subBtn && subBtn.classList.contains('is-on');
    if (on && planId) {
      planInput.value = planId;
      planInput.removeAttribute('disabled');
    } else {
      planInput.value = '';
      planInput.setAttribute('disabled', 'disabled');
    }
  }

  function initBuyBox(root) {
    if (!root || root.dataset.nabiBuyReady === '1') return;
    root.dataset.nabiBuyReady = '1';

    var form = findBuyForm(root);
    var offers = qsa(root, '.sr-offer');
    var subBtn = qs(root, '.sr-sub');
    var cta = qs(root, '.sr-cta');

    function onOfferActivate(offer) {
      applyOffer(root, offer);
    }

    offers.forEach(function (offer) {
      var radio = qs(offer, 'input[type="radio"]');
      if (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) onOfferActivate(offer);
        });
      }
      offer.addEventListener('click', function (e) {
        // Ensure selection even if the click hits nested spans
        if (e.target && e.target.closest && e.target.closest('a,button[type="submit"]')) return;
        onOfferActivate(offer);
      });
    });

    var initial = qs(root, '.sr-offer.is-on') ||
      qs(root, '.sr-offer:has(.sr-offer__input:checked)') ||
      offers[0];
    if (initial) onOfferActivate(initial);

    if (subBtn) {
      subBtn.addEventListener('click', function () {
        subBtn.classList.toggle('is-on');
        subBtn.setAttribute('aria-pressed', subBtn.classList.contains('is-on') ? 'true' : 'false');
        syncPlan(root);
      });
      syncPlan(root);
    }

    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var vidInput = qs(form, 'input[name="id"]');
      var planInput = qs(form, 'input[name="selling_plan"]');
      var id = vidInput ? vidInput.value : '';
      if (!id) return;
      if (cta) {
        cta.classList.add('is-loading');
        cta.disabled = true;
      }
      var item = { id: parseInt(id, 10), quantity: 1 };
      if (planInput && planInput.value && !planInput.disabled) {
        item.selling_plan = parseInt(planInput.value, 10);
      }
      var fallback = '/cart/' + id + ':1';
      if (item.selling_plan) fallback += '?selling_plan=' + item.selling_plan;

      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(item)
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          window.location.href = fallback;
        });
    });
  }

  /* ---------- UGC videos ---------- */
  function initUgc(root) {
    if (!root || root.dataset.nabiUgcReady === '1') return;
    root.dataset.nabiUgcReady = '1';
    qsa(root, '.sr-clip').forEach(function (clip) {
      var btn = qs(clip, '.sr-clip__poster');
      var video = qs(clip, 'video');
      if (!btn || !video) return;
      btn.addEventListener('click', function () {
        qsa(root, '.sr-clip video').forEach(function (v) {
          if (v !== video) {
            v.pause();
            var other = v.closest('.sr-clip');
            if (other) other.classList.remove('is-playing');
          }
        });
        clip.classList.add('is-playing');
        btn.hidden = true;
        video.controls = true;
        video.play().catch(function () {});
      });
    });
  }

  /* ---------- Reviews slider ---------- */
  function initReviews(root) {
    if (!root || root.dataset.nabiReviewsReady === '1') return;
    root.dataset.nabiReviewsReady = '1';
    var track = qs(root, '.hc-track');
    if (!track) return;
    var cards = qsa(root, '.hc-card');
    var prev = qs(root, '.hc-arrow--prev');
    var next = qs(root, '.hc-arrow--next');
    var i = 0;

    function perView() {
      var w = window.innerWidth;
      if (w <= 749) return 1;
      if (w <= 989) return 2;
      return 3;
    }

    function go(n) {
      var pv = perView();
      var max = Math.max(0, cards.length - pv);
      i = Math.max(0, Math.min(max, n));
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      var cardW = cards[0] ? cards[0].getBoundingClientRect().width : 0;
      track.style.transform = 'translateX(' + (-i * (cardW + gap)) + 'px)';
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i >= max;
    }

    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    window.addEventListener('resize', function () { go(i); });
    go(0);
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(root) {
    if (!root || root.dataset.nabiFaqReady === '1') return;
    root.dataset.nabiFaqReady = '1';
    qsa(root, '.faq-imgs__item').forEach(function (item) {
      var btn = qs(item, '.faq-imgs__question');
      var ans = qs(item, '.faq-imgs__answer');
      if (!btn || !ans) return;
      btn.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        qsa(root, '.faq-imgs__item').forEach(function (other) {
          other.classList.remove('is-open');
          var a = qs(other, '.faq-imgs__answer');
          if (a) a.style.maxHeight = '0px';
          var b = qs(other, '.faq-imgs__question');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          ans.style.maxHeight = ans.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function boot(scope) {
    var root = scope || document;
    var hero = root.id === 'nabi-hero' || (root.classList && root.classList.contains('nabi-hero'))
      ? root
      : (qs(root, '#nabi-hero') || qs(root, '.nabi-hero'));
    if (hero) {
      delete hero.dataset.nabiGalleryReady;
      delete hero.dataset.nabiBuyReady;
      delete hero.dataset.nabiUgcReady;
      initGallery(hero);
      initBuyBox(hero);
      initUgc(hero);
    }
    var reviews = root.classList && root.classList.contains('nabi-reviews')
      ? root
      : qs(root, '.nabi-reviews');
    if (reviews) {
      delete reviews.dataset.nabiReviewsReady;
      initReviews(reviews);
    }
    var faq = root.classList && root.classList.contains('nabi-faq')
      ? root
      : qs(root, '.nabi-faq');
    if (faq) {
      delete faq.dataset.nabiFaqReady;
      initFaq(faq);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target || document);
  });
})();
